<template>
  <div data-testid="appointment-details-yard-location-data">
    <p class="typography-body-sm">
      {{ spotAreaName }}
    </p>
    <h3 class="typography-title-sm">
      {{ spotCode }}

      <v-btn icon @click="goToSpot" variant="text" size="small" :title="t('yard.buttons.goToSpot')">
        <v-icon>mdi-arrow-top-right</v-icon>
      </v-btn>
    </h3>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useNotify } from '@/composables';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAppointmentDetailsYardLocation',
  props: {
    spotAreaName: {
      type: String,
      required: true
    },
    spotCode: {
      type: String,
      required: true
    },
    spotId: {
      type: String,
      required: true
    },
    warehouseId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const yardStore = useYard();
    const notify = useNotify();
    const { t } = useI18n();

    const goToSpot = async () => {
      try {
        await yardStore.goToSpotFromOtherModules({
          spotId: props.spotId,
          spotCode: props.spotCode,
          warehouseId: props.warehouseId
        });
      } catch (err) {
        notify(`${t('yard.messages.failedToNavigateToSpot')}: ${err}`, 'error');
        console.error(`Error navigating to spot: ${err}`);
      }
    };

    return {
      t,
      goToSpot
    };
  }
});
</script>
